export const scrollToBookingStep = (idx: number, delay: number): void => {
    const stepElement = document.getElementById(`step-wrapper-${idx}`);
    if (stepElement) {
        setTimeout(function () {
            stepElement.scrollIntoView({ behavior: 'smooth' });
        }, delay);
    }
};
